import { useEffect, useState } from 'react'
import { Card } from '../../components/ui/card'
import { Link } from 'react-router-dom'
import { getLegalConfig } from '../../services/config'
import { LEGAL_TERMS_VERSION } from '../../constants/legal'

interface SectionItem {
  title: string
  paragraphs: string[]
}

interface LegalPageLayoutProps {
  pageTitle: string
  effectiveDate: string
  sections: SectionItem[]
}

export default function LegalPageLayout({
  pageTitle,
  effectiveDate,
  sections,
}: LegalPageLayoutProps) {
  const [displayVersion, setDisplayVersion] = useState(LEGAL_TERMS_VERSION)

  useEffect(() => {
    let cancelled = false
    getLegalConfig()
      .then((res) => {
        if (!cancelled && res.data?.legalTermsVersion) {
          setDisplayVersion(res.data.legalTermsVersion)
        }
      })
      .catch(() => {
        // Keep fallback version if config API is temporarily unavailable.
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f7fb',
        padding: '32px 16px',
      }}
    >
      <div style={{ maxWidth: 920, margin: '0 auto' }}>
        <Card className="p-6 sm:p-10">
          <div style={{ marginBottom: 24 }}>
            <h1 className="text-2xl font-semibold" style={{ marginBottom: 8 }}>
              {pageTitle}
            </h1>
            <span className="text-muted-foreground">
              版本：{displayVersion}
            </span>
            <br />
            <span className="text-muted-foreground">
              生效日期：{effectiveDate}
            </span>
          </div>

          {sections.map((section) => (
            <div key={section.title} style={{ marginBottom: 20 }}>
              <h2 className="text-lg font-semibold" style={{ marginBottom: 8 }}>
                {section.title}
              </h2>
              {section.paragraphs.map((item, index) => (
                <p
                  key={`${section.title}-${index}`}
                  style={{ marginBottom: 8 }}
                >
                  {item}
                </p>
              ))}
            </div>
          ))}

          <p className="text-muted-foreground" style={{ marginTop: 24 }}>
            如有疑問，請聯絡：admin@kyren.io
          </p>
          <p style={{ marginBottom: 0 }}>
            <Link to="/">返回登入頁</Link>
          </p>
        </Card>
      </div>
    </div>
  )
}
